exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n.loaderWrapper___2qe1b {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n.drawerBody___3TC-A {\n  min-height: 100vh;\n  padding: 20px 20px 84px 20px;\n}\n@media (min-width: 768px) {\n  .drawerBody___3TC-A {\n    padding: 40px 40px 110px 40px;\n  }\n}\n.drawerButtons___1pf83 {\n  position: fixed;\n  bottom: 0;\n  padding: 20px 40px;\n  width: 100%;\n  background-color: #fff;\n  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);\n}\n@media (min-width: 768px) {\n  .drawerButtons___1pf83 {\n    width: 622px;\n  }\n}\n.drawerTitle___1PZ5d {\n  color: #21201f;\n  font-family: 'poynter-oldstyle-display', serif;\n  font-size: 32px;\n  font-weight: 600;\n  letter-spacing: normal;\n  line-height: 1.13;\n}\n.drawerSubtitle___EaxRm {\n  color: #505050;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.75;\n  letter-spacing: normal;\n  margin-bottom: 22px;\n}\n", ""]);

// exports
exports.locals = {
	"loaderWrapper": "loaderWrapper___2qe1b",
	"drawerBody": "drawerBody___3TC-A",
	"drawerButtons": "drawerButtons___1pf83",
	"drawerTitle": "drawerTitle___1PZ5d",
	"drawerSubtitle": "drawerSubtitle___EaxRm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/modals/ProjectCloneModal/styles.module.less
// module id = 1696
// module chunks = 71